module.exports = __webpack_public_path__ + "static/roentgen.2eab88c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/devices/roentgen.jpg
// module id = 159
// module chunks = 33781710060979 118332546261619